import { render, staticRenderFns } from "./fengrenhetong.vue?vue&type=template&id=b51c4a82&scoped=true&"
import script from "./fengrenhetong.vue?vue&type=script&lang=js&"
export * from "./fengrenhetong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51c4a82",
  null
  
)

export default component.exports